import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';

const aboutJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: '关于我们 - 蜜芽永不失联',
  description:
    '蜜芽永不失联致力于为用户整合蜜芽平台的最新官方联系方式、客服入口、订单查询及社群渠道信息，确保每位用户随时都能找到蜜芽。',
  url: 'https://miya-official.com/about',
  isPartOf: {
    '@type': 'WebSite',
    name: '蜜芽永不失联',
    url: 'https://miya-official.com',
  },
};

export default function AboutPage() {
  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutJsonLd) }}
      />
      <div className="min-h-screen bg-white">
        <Navbar />
        <main className="pt-20 pb-14">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />

            <h1
              className="text-3xl md:text-4xl font-bold text-foreground-950 mt-6 mb-8"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              关于我们
            </h1>

            <section className="mb-12">
              <h2 className="text-xl font-semibold text-foreground-950 mb-4">
                品牌介绍
              </h2>
              <div className="mb-6 rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20warm%20and%20inviting%20modern%20office%20lounge%20space%20with%20comfortable%20seating%20and%20green%20plants%2C%20soft%20natural%20light%20streaming%20through%20large%20windows%2C%20minimalist%20interior%20design%20with%20cream%20and%20beige%20tones%2C%20clean%20and%20professional%20atmosphere%2C%20welcoming%20brand%20environment%2C%20aspirational%20lifestyle%20aesthetic%2C%20no%20people%20visible&width=1200&height=500&seq=about-brand&orientation=landscape"
                  alt="蜜芽永不失联品牌形象"
                  title="蜜芽永不失联 - 品牌介绍"
                  className="w-full h-auto object-cover"
                />
              </div>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                蜜芽永不失联是一个专注于为蜜芽平台用户提供信息服务的独立信息门户。我们的使命是确保每一位蜜芽用户都能随时随地找到官方渠道，获取所需的客服支持、订单查询服务和最新促销资讯。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                在电商平台日益复杂的今天，消费者常常面临找不到客服、查询订单困难、错过优惠活动等问题。蜜芽永不失联应运而生，我们汇聚了蜜芽所有官方联系方式和渠道信息，以清晰易懂的方式呈现给用户，帮助大家节省时间、解决问题。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                我们持续关注蜜芽平台的最新动态，及时更新相关信息，确保用户获取的内容始终准确有效。无论是APP更新、客服渠道变更还是促销活动通知，我们都会第一时间进行汇总发布。
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-xl font-semibold text-foreground-950 mb-4">
                用户口碑
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                {[
                  {
                    name: '小敏妈妈',
                    text: '蜜芽永不失联真的太实用了！之前一直找不到蜜芽的客服电话，在这里一次就找到了所有联系方式，还学会了怎么查物流，超级感谢！',
                    rating: 5,
                  },
                  {
                    name: '果果宝妈',
                    text: '社群渠道汇总帮了大忙，加了官方微信群后第一时间知道了会员日优惠，买到了超划算的纸尿裤，省了不少钱！',
                    rating: 5,
                  },
                  {
                    name: '丫丫的妈咪',
                    text: '退换货指南写得很清楚，按照步骤操作很快就完成了退货。以前自己摸索半天都搞不定，这个网站真的太贴心了。',
                    rating: 5,
                  },
                  {
                    name: '乐乐爸',
                    text: '作为一个奶爸，蜜芽永不失联帮我节省了很多时间。订单查询、支付方式对比这些内容都写得简单易懂，推荐给所有新手爸妈！',
                    rating: 5,
                  },
                  {
                    name: '小鱼儿',
                    text: '信息更新及时，每次蜜芽有新的活动都能在这里看到汇总。文章内容详细又实用，已成为我的蜜芽使用指南了。',
                    rating: 5,
                  },
                  {
                    name: '晨晨妈妈',
                    text: '感谢蜜芽永不失联整理了这么全面的FAQ，大部分问题在这里都能找到答案，不用再排队等客服了，效率提高了好多！',
                    rating: 5,
                  },
                ].map((review, index) => (
                  <div
                    key={index}
                    className="bg-background-50 rounded-lg p-5"
                  >
                    <div className="flex gap-0.5 mb-3">
                      {Array.from({ length: review.rating }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-amber-400 text-sm"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                      &ldquo;{review.text}&rdquo;
                    </p>
                    <p className="text-xs font-medium text-foreground-900">
                      —— {review.name}
                    </p>
                  </div>
                ))}
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-xl font-semibold text-foreground-950 mb-4">
                联系方式
              </h2>
              <div className="bg-background-50 rounded-lg p-6">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-mail-line"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900 mb-1">
                        电子邮箱
                      </h3>
                      <p className="text-sm text-foreground-600">
                        contact@miya-official.com
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-wechat-line"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900 mb-1">
                        微信公众号
                      </h3>
                      <p className="text-sm text-foreground-600">
                        蜜芽永不失联
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-timer-line"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900 mb-1">
                        工作时间
                      </h3>
                      <p className="text-sm text-foreground-600">
                        周一至周日 9:00 - 22:00
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-information-line"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900 mb-1">
                        免责声明
                      </h3>
                      <p className="text-sm text-foreground-600">
                        本站为独立信息聚合平台，非蜜芽官方运营。我们致力于提供准确的官方渠道信息，如有疑问请以蜜芽官方公告为准。
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}